import './Dashboard.scss';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getSubscriptionPlanByIdApi, getUserItineraryCountApi } from '../../../services/AdminService';
import { useAuth } from '../../../contexts/AuthProvider';
import { DashboardPlaceholder } from '../../../components/skeleton-placeholder';
import AlertMessage from '../../../components/alert-message';

const Dashboard = () => {
    const [getCount, setGetCount] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState();
    const history = useHistory();
    const { authed } = useAuth();

    const getCountList = async () => {
        setIsLoading(true);
        await getUserItineraryCountApi({ userId: authed?.user?._id }, async (res) => {
            if (res.status === 200) {
                setGetCount(res.data);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
            setIsLoading(false);
        });
    }

    const getSubscriptionPlanById = async () => {
        await getSubscriptionPlanByIdApi({ userId: authed?.user?._id }, async (res) => {
            // console.log("getSubscriptionPlanById res.data===>,", res.data)
            if (res.status === 200) {
                setSubscriptionData(res.data.subscription);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }
    const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0;
    useEffect(() => {
        getCountList();
        getSubscriptionPlanById();
    }, []);
    
    return (
        <>

            <div className="pt-3">
                <h1 className="d-col-title mb-3">Dashboard</h1>
                {subscriptionData && !isEmptyObject(subscriptionData) && <AlertMessage subscription={subscriptionData} />}
                <div className="row">
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-1" onClick={() => history.push(`/admin/itineraries-list`)}>
                                <p className="dash-item-title">My Itineraries</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.publicItinerary + getCount?.privateItinerary) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-2" onClick={() => history.push(`/admin/itineraries-list`)}>
                                <p className="dash-item-title">Public Itineraries</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.publicItinerary) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/itineraries-list`)}>
                                <p className="dash-item-title">Private Itineraries</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.privateItinerary) : "0"}</span>
                            </div>
                        }
                    </div>
                     <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/itinerary-draft-list`)}>
                                <p className="dash-item-title">Draft Itineraries</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.draftItinerary) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/transport`)}>
                                <p className="dash-item-title">My Transport</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.transportData) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/stays`)}>
                                <p className="dash-item-title">My Stays</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.staysData) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/foods`)}>
                                <p className="dash-item-title">My Foods</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.foodData) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/activities`)}>
                                <p className="dash-item-title">My Activities</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.activityData) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/tours`)}>
                                <p className="dash-item-title">My Tours</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.tourData) : "0"}</span>
                            </div>
                        }
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-3 mt-3">
                        {isLoading ? <DashboardPlaceholder /> :
                            <div className="dash-item-bx dash-item-bg-3" onClick={() => history.push(`/admin/others`)}>
                                <p className="dash-item-title">Others</p>
                                <span className="dash-item-count">{getCount ? Number(getCount?.othersData) : "0"}</span>
                            </div>
                        }
                    </div>
                </div>
            </div>

        </>
    );
}

export default Dashboard;